import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { PoTableColumn } from "@po-ui/ng-components";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class OrcamentoFormService {
  constructor(private http: HttpClient) {}

  ipi: number;
  icms: number;
  total: number;
  _impostos;
  urlSimilar = `${environment.API}similar`;
  urlCliente = `${environment.API}clientes`;
  urlProdutos = `${environment.API}produtos`;
  urlTransportadoras = `${environment.API}transportadoras`;
  urlPreco = `${environment.API}tabprc_1`;
  urlcabOrcamento = `${environment.API}cabOrcamento`;
  urlItensOrcamento = `${environment.API}itensorcamento`;
  urlcondPagamentos = `${environment.API}condpagamentos`;
  urlDesconto = `${environment.API}desconto`;
  urlImpostos = `${environment.API}consultaimposto`;
  urlEstoque = `${environment.API}protheus/estoque`;
  urlParam = `${environment.API}parametro/0301/`;
  get headers(): HttpHeaders {
    return new HttpHeaders({ authorization: sessionStorage.getItem("token") || "" });
  }

  async getImpostos(Cliente: String, Dados: Object,empresa: String): Promise<any> {
       const data = await this.http
      .post(this.urlImpostos + "/?dados=" + Cliente.trim() + "&emp="+empresa, Dados, {headers: this.headers} )
      .toPromise();
    return data;
  }

  getColumns(): Array<PoTableColumn> {
    return [
      { property: "code", type: "number", width: "8%", label: "Código" },
      { property: "product", label: "Produto",  width: "20%" },
      { property: "unidadem", label: "U.M", width: "8%" },
      {
        property: "quantity",
        label: "Quantidade",
        type: "number",
        width: "10%",
      },
      ,
      {
        property: "vlruni",
        label: "Valor Un.",
        type: "number",
        format: "1.2-5",
        width: "10%"
      },
      {
        property: "vlruni_imp",
        label: "Vlr + Impostos",
        type: "number",
        format: "1.2-5",
        width: "12%"
      },
    
      { property: "total", label: "Total", type: "number", format: "1.1-2",width: "8%" },
    ];
  }
  
  //Observable<Array<PoComboOption>
  getClientes(Cliente: String): Observable<any> {
    return this.http.post(this.urlCliente, { filter: Cliente },{headers: this.headers});
  }

  getPreco(codTabela: string, codProduto: string, segmento: string): Observable<any> {
    return this.http.post(this.urlPreco, { codTabela, codProduto, segmento},{headers: this.headers});
  }

  getProdutos(segmento,filtro,tpconsulta,tab, ufCliente): Observable<any> {
    return this.http.post(this.urlProdutos, {segmento,filter:filtro,tpconsulta,tab,ufCliente},{headers: this.headers});
  }

  getProdutoByCodigo(codigo: string): Observable<any> {
    return this.http.get(`${environment.API}produtos/${codigo}`, { headers: this.headers });
  }

  getcondPagamentos(filter): Observable<any> {
    return this.http.post(this.urlcondPagamentos, {filter},{headers: this.headers});
  }

  getDesconto(tabela: String, condpagamento: String): Observable<any> {
    return this.http.post(this.urlDesconto, {
      tiporeq: "C",
      tabela: tabela,
      condpagamento: condpagamento,
    },{headers: this.headers});
  }
 
  getSimilar(codigo: String): Observable<any> {
    return this.http.post(this.urlSimilar, { codigo },{headers: this.headers});
  }

  getItems(): Array<any> {
    return [];
  }

  getLimiteNoCartao(): Observable<any> {
    return this.http.get(this.urlParam + "MV_XNOCART", {headers: this.headers});
  }

  getValorMinimo(): Observable<any> {
    return this.http.get(this.urlParam + "MV_XVALMIN", {headers: this.headers});
  }

  generateNewItem(
    index: number,
    quantidade: number,
    nome: string,
    codigo: string,
    preco: number,
    precoImposto: number,
    um: string,
    desconto: number,
    ipi: number,
    icms: number,
  ) {
    
    if (Number.isNaN(desconto)){
      desconto = 0
    }
    
    const total = (precoImposto - desconto) * quantidade;
    
    return {
      // id: index,
      code: codigo,
      product: nome,
      unidadem: um,
      quantity: quantidade,
      ipi: this.convertToBrl(ipi / 100),
      icms: this.convertToBrl(icms / 100),
      desconto: this.convertToBrl(desconto / 100),
      vlruni: this.convertToBrl(preco / 100),
      vlruni_imp: this.convertToBrl(precoImposto / 100),
      total: this.convertToBrl(total / 100)
    };
  }

  convertToBrl(valor:number){
    // const formatado = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
    if (Number.isNaN(valor)){
      valor = 0
    }
    const formatado = valor //Remove a formatacao por causa de problemas no calculo dos totais
    return formatado
  }

  generateNewItemSimilar(
    codigo: string,
    descricao: string
  ) {
    return {
      codigo: codigo,
      produto: descricao,
    };
  }

  SalvaCabOrcamento(cabOrcamento: Array<any>): Observable<any> {
    return this.http.put(this.urlcabOrcamento, cabOrcamento,{headers: this.headers});
  }

  SalvaItensOrcamento(itens: Array<any>): Observable<any> {
    return this.http.put(this.urlItensOrcamento, itens,{headers: this.headers});
  }

  
  getProdutosColumns(): Array<PoTableColumn> {
    return [
      { property: 'codigo', type: 'number', width: '30%' },
      { property: 'produto', width: '60%' },
      { property: 'especif', width: '10%', visible:false },
      { property: 'un',width: '10%' },
     
    ];
  }
  
  getSimilarColumns(): Array<PoTableColumn> {
    return [
      { property: 'codigo', type: 'number', width: '15%' },
      { property: 'produto', width: '60%' },
    ];
  }


  async getEstoqueP(produto: String): Promise<any> {
    const data = await this.http.get(this.urlEstoque +"/?produtob2="+produto+"&cadastro=TRUE", {headers: this.headers})
      .toPromise();
     // console.log(data);
    return data;
  }
  



}
